import {FC} from 'react'

import {theme} from '@/theme/theme'

import {PaymentIcon, SupportedCards} from '../common/icons/PaymentIcon'

const paymentMethods: SupportedCards[] = ['visa', 'mastercard']

type PaymentMethodsProps = {
  supportedCards?: SupportedCards[]
}

export const PaymentMethods: FC<PaymentMethodsProps> = ({supportedCards = paymentMethods}) => {
  return (
    <>
      <ul className="list">
        {supportedCards.map((brand) => (
          <li key={brand} className="item">
            <PaymentIcon brand={brand} />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          align-items: center;
        }

        .item + .item {
          margin-left: ${theme.spacing[2]};
        }
      `}</style>
    </>
  )
}
